(ns ui.drawer
  (:require ["@radix-ui/react-dialog" :as RadixDialog]
            [ui.dialog :as dialog]
            [ui.utils :refer [clsx separate-props]]))

;; Inspired by
;; https://github.com/jordan-sussman/open-sesame/blob/main/src/OpenSesame/index.tsx

;; TODO: support for origin, radius, and size

(def drawer-root dialog/dialog-root)
(def drawer-trigger dialog/dialog-trigger)
(def drawer-title dialog/dialog-title)
(def drawer-description dialog/dialog-description)
(def drawer-close dialog/dialog-close)
(def drawer-close-x dialog/dialog-close-x)
(def drawer-actions dialog/dialog-actions)

(defn drawer-body [& args]
  (let [[props children] (separate-props args)]
    (into [:div (update props :class #(clsx "mt-4" %))]
          children)))

;; Full-viewport drawer content for resizable split layouts.
;; In non-modal usage, content is pointer-events-none so the page behind
;; remains interactive; the visible drawer pane must opt back in.
;; Use :force-mount when the split layout should preserve pane state.
(defn drawer-content-resizable [& args]
  (let [[props children] (separate-props args)]
    [:> RadixDialog/Portal {:data-slot   "dialog-portal"
                            :force-mount (:force-mount props)}
     [:> RadixDialog/Overlay {:data-slot "dialog-overlay"
                              :class     "fixed inset-0 z-2000 pointer-events-none"}]
     (into
      [:> RadixDialog/Content
       (-> {:data-slot            "dialog-content"
            :aria-describedby    js/undefined
            :on-open-auto-focus  #(.preventDefault %)
            :on-interact-outside #(.preventDefault %)}
           (merge props)
           (update :class #(clsx "fixed inset-0 z-2000 outline-none pointer-events-none" %)))]
      children)]))

(defn drawer-content [& args]
  (let [[props children] (separate-props args)
        x-close (if (contains? props :x-close) (:x-close props) true)]
    (into [dialog/dialog-content
           (-> props
               (dissoc :x-close)
               (assoc :x-close false) ;; drawer renders its own close button below
               (update :class #(clsx "max-h-screen shadow-md fixed left-auto right-0 top-0 bottom-0 translate-none w-96 rounded-r-none grid grid-rows-[auto_1fr]"
                                     "transform-gpu"
                                     "animate-fade-left animate-duration-200"
                                     %)))]
          (concat children
                  (when x-close [[drawer-close-x]])))))

(defn drawer [{:keys [open on-open-change title description content
                      root-props content-props actions actions-props
                      origin size radius x-close content-wrapper-class]
               :or {root-props {}
                    content-props {}
                    x-close true
                    origin "right" ;; top right left bottom
                    radius 0 ;; border radius of the drawer, in px
                    size 300 ;; number of pixels or percentage as string
                    }}
              trigger]

  [drawer-root (merge root-props
                      {:open           open
                       :on-open-change on-open-change})

   (when trigger
     [drawer-trigger trigger])

   [drawer-content (assoc content-props :x-close x-close)
    (when title [drawer-title title])
    (when description [drawer-description description])
    [drawer-body {:class content-wrapper-class} content]
    (when actions
      [drawer-actions actions-props
       actions])]])
